import styled, { css } from "styled-components";
import { BRAND_DARK, WHITE } from "@streeteasy/design-system/colors";
import actionElements from "@streeteasy/design-system/constants/actionElements";
import colors from "@streeteasy/design-system/deprecated/colors";
import TextAction, {
  textActionTypography
} from "@streeteasy/design-system/text-action";

import { largeScreen } from "src/shared/constants/screenSizes";

export const HeaderNavButton = styled(TextAction).attrs({
  underlined: false,
  element: actionElements.button,
  typography: textActionTypography.BODY
})`
  && {
    cursor: pointer;
    line-height: 50px;
    position: relative;
    padding: 0 15px;
    color: ${WHITE};
    @media screen and (max-width: ${largeScreen}px) {
      color: ${colors.whaleGrey};
      padding: 0 20px;
      margin: 12px 0;
      font-size: 20px;
      width: 100%;
      display: inline-block;
      margin: 0;
    }

    &:hover,
    &:active,
    &:focus {
      color: ${WHITE};
      background: none;
      background-color: inherit;
      text-decoration: underline;
      fill: ${BRAND_DARK};
      outline: revert;
      outline-offset: 0;
      @media screen and (max-width: ${largeScreen}px) {
        color: ${colors.whaleGrey};
        text-decoration: none;
      }
    }

    ${({ isNew }) =>
      isNew
        ? css`
            &:before {
              background-color: ${colors.accent2};
              border-radius: 50%;
              content: "";
              display: block;
              height: 6px;
              position: absolute;
              top: 14px;
              transform: translateX(-100%);
              width: 6px;
            }
          `
        : ""}
  }
`;
